import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { getAccessToken } from '@/utils/localStorage';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api';

const baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
	args,
	api,
	extraOptions
) => {
	// Get token from localStorage instead of cookies
	const token = getAccessToken();
	
	const result = await fetchBaseQuery({
		baseUrl: API_BASE_URL,
		prepareHeaders: (headers, { extra }) => {
			if (token) {
				headers.set('Authorization', `Bearer ${token}`);
			}
			// Don't set Content-Type for FormData - let browser set it with boundary
			const body = typeof args === 'string' ? null : (args as FetchArgs)?.body;
			if (!(body instanceof FormData)) {
				headers.set('Content-Type', 'application/json');
			}
			return headers;
		}
	})(args, api, extraOptions);

	// Handle 401 errors (unauthorized)
	if (result.error && result.error.status === 401) {
		// Clear auth storage and redirect to login
		// This will be handled by ProtectedRoute
	}

	return result;
};

export const apiService = createApi({
	baseQuery,
	endpoints: () => ({}),
	reducerPath: 'apiService'
});

export default apiService;

